import { List } from 'immutable';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import * as A from '../../../actions';
import * as D from '../../../deps';
import { getBackstageAnnotation, getUserStationId } from '../../../utils';
import LayoutManager from '../../layout/LayoutManager';

import BackstageArtistDataFetcher from './BackstageArtistDataFetcher';

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
const BackstageArtist = props => {
  const { annotateObjectsForBackstage, getArtistEventsForBackstage, pandoraId } = props;
  const encryptedPandoraId = props.params.pandoraId;

  useEffect(() => {
    annotateObjectsForBackstage(List([encryptedPandoraId]));
  }, [encryptedPandoraId, annotateObjectsForBackstage]);

  useEffect(() => {
    getArtistEventsForBackstage(pandoraId);
  }, [pandoraId, getArtistEventsForBackstage]);

  if (!pandoraId) {
    return <LayoutManager />;
  }

  return <BackstageArtistDataFetcher {...props} />;
};

// @ts-expect-error TS(7006) FIXME: Parameter 'state' implicitly has an 'any' type.
export function mapStateToProps(state, ownProps) {
  const encryptedId = get(ownProps, 'params.pandoraId', '');
  const annotation = getBackstageAnnotation(state, encryptedId);

  if (
    !annotation ||
    annotation.isEmpty() ||
    ![D.PandoraTypes.ARTIST, D.PandoraTypes.COMPOSER].includes(annotation.get('type'))
  ) {
    return {};
  }
  const pandoraId = annotation.get('pandoraId');

  const isAudioPlaying = D.getInDomain('playback.utils.isAudioPlaying', false);
  const isInitialAppLoad = D.getInDomain('application.utils.isInitialLoad', false);
  const isPlaylistOn = D.getInDomain('playback.utils.isSourcePlayingCurrently', false);
  const userStationId = getUserStationId(state, pandoraId);
  const artistImg = D.getArt(annotation, 300, state);
  const catalogDetails = D.getInDomain('catalog.utils.getCatalogDetailsFromState')(
    state,
    pandoraId,
  );

  return {
    currentlyPlayingPandoraId: D.getInDomain('playback.utils.getCurrentPlaylist', '')(state),
    defaultArtUrl: artistImg ? artistImg : D.getHero(state, catalogDetails, 300),
    initialLoadAnnotation: isInitialAppLoad(state) ? annotation : null,
    isArtistStationPlaying: userStationId && isPlaylistOn(state, userStationId),
    isAudioPlaying: isAudioPlaying(state),
    isMobileWeb: D.isMobileWeb(state),
    isRightRailActive:
      D.getInDomain('ads.utils.getIsRightRailActive', false)(state) ||
      D.getInDomain('ads.utils.getIsElementCenteredWithAds', false)(state),
    nowPlayingUrl: D.getStationPlayPathForStationCode(userStationId),
    pandoraId,
  };
}

const mapDispatchToProps = {
  annotateObjectsForBackstage: A.annotateObjectsForBackstage,
  closeModal: D.closeModal,
  getArtistEventsForBackstage: A.getArtistEventsForBackstage,
  openModal: D.openModal,
  openServiceErrorToast: D.Actions.Modal.openServiceErrorToast,
  openShareModal: D.Actions.Share.openShareModal,
  pauseTrack: D.Actions.UseCases.pauseTrack,
  playResumeSource: D.playResumeSource,
  startStation: D.Actions.UseCases.startStation,
};

BackstageArtist.propTypes = {
  annotateObjectsForBackstage: PropTypes.func.isRequired,
  closeModal: PropTypes.func,
  currentlyPlayingPandoraId: PropTypes.string,
  getArtistEventsForBackstage: PropTypes.func.isRequired,
  getCatalogDetailsForBackstage: PropTypes.func.isRequired,
  isArtistStationPlaying: PropTypes.bool,
  isAudioPlaying: PropTypes.bool,
  isCuratorExperienceEnabled: PropTypes.bool,
  isMobileWeb: PropTypes.bool,
  isRightRailActive: PropTypes.bool,
  nowPlayingUrl: PropTypes.string,
  openModal: PropTypes.func,
  openShareModal: PropTypes.func,
  pandoraId: PropTypes.string,
  params: PropTypes.shape({
    pandoraId: PropTypes.string,
  }),
  pauseTrack: PropTypes.func,
  playResumeSource: PropTypes.func,
  startStation: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(BackstageArtist);
